import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Input, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"
import Shimmer from 'react-shimmer-effect'

import apiResponse from '../../../../services/apiResponse'

import IndexBloc from '../Index/Blocs/IndexBloc'

class IndexView extends Component {

    timer
    indexBloc = new IndexBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            positionOption: [],
            positionFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'position_id',
                    order: 'asc' 
                }
            },
        }
    }

    loadDetail = async () => {
        await this.indexBloc.fetchDetail({ uuid: this.props.uuid })
    }

    componentDidMount() {
        this.loadDetail()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break
                default:
                    break
            }
        })       

    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/master/level_tunjangan_khusus.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Detail Level Tunjangan Khusus</CardTitle>
                            <hr />
                            <Row className="mb-3">
                                <label
                                    htmlFor="special_level_name"
                                    className="col-md-3 col-form-label"
                                >
                                    Nama  
                                </label>
                                <Col md="3">
                                { detail ? 
                                    <Label className="col-form-label">
                                        {detail?.special_level_name || "-"}
                                    </Label>
                                    :
                                    <Shimmer>
                                        <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                    </Shimmer>
                                }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label
                                    htmlFor="special_level_description"
                                    className="col-md-3 col-form-label"
                                >
                                    Deskripsi  
                                </label>
                                <Col md="3">
                                { detail ? 
                                    <Label className="col-form-label">
                                        {detail?.special_level_description || "-"}
                                    </Label>
                                    :
                                    <Shimmer>
                                        <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                    </Shimmer>
                                }
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <label
                                    htmlFor="special_level_id"
                                    className="col-md-3 col-form-label"
                                >
                                    Kode
                                </label>
                                <Col md="3">
                                { detail ? 
                                        <Label className="col-form-label">
                                            {detail?.special_level_code || "-"}
                                        </Label>
                                        :
                                        <Shimmer>
                                            <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                        marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                        </Shimmer>
                                    }
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                </Container>
               
            </Fragment>
        )
    }

}

export default IndexView